import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService, IndividualConfig } from 'ngx-toastr';

@Injectable({
	providedIn: 'root',
})
export class ToastService {
	private defaultOptions: Partial<IndividualConfig> = {
		closeButton: true,
		progressBar: true,
		progressAnimation: 'decreasing',
		positionClass: 'toast-bottom-center',
		timeOut: 5000,
	};

	private toastr = inject(ToastrService);
	private translateService = inject(TranslateService);

	success(message: string, title: 'Success', options?: Partial<IndividualConfig>) {
		const m = this.translateService.instant(message);
		const t = this.translateService.instant(title);
		this.toastr.success(m, t, { ...this.defaultOptions, ...options });
	}

	error(message: string, title: 'Error', options?: Partial<IndividualConfig>) {
		const m = this.translateService.instant(message);
		const t = this.translateService.instant(title);
		this.toastr.error(m, t, { ...this.defaultOptions, ...options });
	}

	warning(message: string, title: 'Warning', options?: Partial<IndividualConfig>) {
		const m = this.translateService.instant(message);
		const t = this.translateService.instant(title);
		this.toastr.warning(m, t, { ...this.defaultOptions, ...options });
	}

	info(message: string, title: 'Info', options?: Partial<IndividualConfig>) {
		const m = this.translateService.instant(message);
		const t = this.translateService.instant(title);
		this.toastr.info(m, t, { ...this.defaultOptions, ...options });
	}
}
